/**
 * API Configuration
 * 
 * This file contains all API-related configuration settings.
 * Update the BASE_URL based on your environment.
 */

export { BASE_URL } from "../constants/BaseUrl";

// Base URL for the backend API
// export const BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:8080/";

// API endpoints
export const API_ENDPOINTS = {
  LOGIN: "auth/admin/login", // Admin-specific login endpoint (restricted to SUPER_ADMIN and SUB_ADMIN)
  LOGOUT: "auth/logout",
  PENDING_USERS: "users/pending-approval",
  ALL_USERS: "users",
  EXPORT_USERS: (type) => `users/export?type=${type}`,
  APPROVE_USER: (userId) => `users/${userId}/approve`,
  GET_USER: (userId) => `users/${userId}`,
  UPDATE_USER: (userId) => `users/${userId}/update`,
  BLOCK_USER: (userId) => `users/${userId}/block`,
  UNBLOCK_USER: (userId) => `users/${userId}/unblock`,

  // Announcements (super admin creates these; they pop up on NP login)
  ANNOUNCEMENTS: 'superadmin/announcements',
  ANNOUNCEMENT_DETAIL: (id) => `superadmin/announcements/${id}`,
  CREATE_ANNOUNCEMENT: 'superadmin/announcements',
  UPDATE_ANNOUNCEMENT: (id) => `superadmin/announcements/${id}`,
  REMOVE_ANNOUNCEMENT: (id) => `superadmin/announcements/${id}`,

  // Image upload (shared with storage module)
  UPLOAD_IMAGE: 'storage/upload/image',

  // Get In Touch Queries (contact form submissions)
  GET_IN_TOUCH_QUERIES: "website-queries",

  // Admin Inquiries
  ADMIN_INQUIRIES: "admin-inquiries",
  ADMIN_INQUIRY_MESSAGES: (id) => `admin-inquiries/${id}/messages`,
  ADMIN_INQUIRY_STATUS: (id) => `admin-inquiries/${id}/status`,

  // Dashboard analytics
  SUPERADMIN_DASHBOARD_ANALYTICS: 'superadmin/dashboard/analytics',

  // Reports
  REPORT_NONPROFIT_MATRIX:    'superadmin/reports/nonprofit-matrix',
  REPORT_EVENTS_MONTHLY:      'superadmin/reports/events-monthly',
  REPORT_FLAGGED_EVENTS:      'superadmin/reports/flagged-events',
  REPORT_COLLABORATIONS:      'superadmin/reports/collaborations',
  REPORT_INQUIRY_ENGAGEMENT:  'superadmin/reports/inquiry-engagement',
  REPORT_IMPRESSIONS:         'superadmin/reports/impressions',

  // Event Master List (superadmin view of all events)
  EVENTS: 'superadmin/events',
  EVENT_DETAIL: (id) => `superadmin/events/${id}`,
  UPDATE_EVENT: (id) => `superadmin/events/${id}`,
  PUBLISH_EVENT: (id) => `superadmin/events/${id}/publish`,
  REMOVE_EVENT: (id) => `superadmin/events/${id}`,
  EVENT_COLLABORATION: (id) => `superadmin/events/${id}/collaboration`,
  FLAGGED_EVENTS: 'superadmin/flagged-events',
  FLAGGED_EVENT_DECISION: (id) => `superadmin/flagged-events/${id}/decision`,
};

// Request timeout (in milliseconds)
export const REQUEST_TIMEOUT = 30000;

// Default headers
export const DEFAULT_HEADERS = {
  "Content-Type": "application/json",
};

